"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _ProductRelease = require("./ProductRelease");

var _ProductRelease2 = _interopRequireDefault(_ProductRelease);

var _ReleaseNotes = require("./ReleaseNotes");

var _ReleaseNotes2 = _interopRequireDefault(_ReleaseNotes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = (0, _glamor.css)({
  width: "100%",

  position: "relative"
});

var hr = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(2),
  marginBottom: (0, _css.unitRem)(2.5)
});

var title = (0, _glamor.css)({
  display: "block",

  color: _css.colors.white,
  fontWeight: 300,
  lineHeight: 1.3
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.5,
    medium: 1.685,
    large: [1.685, 2.25]
  }
}));

var titleLink = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1,
    medium: 0.8,
    large: [0.8, 1.125]
  }
}));

var ProductReleaseNotes = function ProductReleaseNotes(props) {
  return _react2.default.createElement(
    "div",
    { className: container },
    _react2.default.createElement(_ProductRelease2.default, {
      icon: props.icon,
      title: props.title,
      buttons: props.buttons,
      download: props.download,
      titleStyle: title,
      titleLinkStyle: titleLink
    }),
    _react2.default.createElement(_Hr2.default, { className: hr }),
    _react2.default.createElement(_ReleaseNotes2.default, { title: "Changes", notes: props.changeLog }),
    _react2.default.createElement(
      "div",
      { className: (0, _glamor.css)({ margin: (0, _css.unitRem)(2) + " 0" }) },
      _react2.default.createElement(_Button2.default, {
        label: props.download.label,
        href: props.download.url,
        mode: "secondary",
        onClick: props.download.onClick
      })
    )
  );
};

exports.default = ProductReleaseNotes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Mixer/Components/ProductReleaseNotes.jsx
// module id = 2944
// module chunks = 0